export function useOrdersWholesaleFilter() {
  const getWholesaleFilterOptionTracking = (isWholesale: string): string => {
    if (isWholesale === '') {
      return String(false);
    }
    return isWholesale === 'true' ? 'wholesale' : 'retail';
  };
  return {
    getWholesaleFilterOptionTracking,
  };
}
